module.exports = $;


/*****************
 ** WEBPACK FOOTER
 ** external "$"
 ** module id = 4
 ** module chunks = 0
 **/